import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { accountService, alertService } from '../_services';
import { useTranslation } from 'react-i18next';

function Register({ history }) {
    const { t } = useTranslation();
    const initialValues = {
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        acceptTerms: false
    };

    const validationSchema = Yup.object().shape({
        //    title: Yup.string()
        //        .required('Title is required'),
        firstName: Yup.string()
            .required(t('First Name is required')),
        lastName: Yup.string()
            .required(t('Last Name is required')),
        email: Yup.string()
            .email(t('Email is invalid'))
            .required(t('Email is required')),
        password: Yup.string()
            .min(6, t('register.passwordMin'))
            .required(t('Password is required')),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], t('Passwords must match'))
            .required(t('Confirm Password is required')),
        //   acceptTerms: Yup.bool()
        //       .oneOf([true], 'Accept Terms & Conditions is required')
    });

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        accountService.register(fields)
            .then(() => {
                alertService.success(t('register.success'), { keepAfterRouteChange: true });
                history.push('login');
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting }) => (
                <Form>
                    <h2 className="card-header">{t('Create An Account')}</h2>
                    <div className="card-body create-pad">
                        <div className="form-row col-8 create-marg">

                            <div className="form-group col">
                                <label>{t('First Name')}</label>
                                <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} />
                                <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group col">
                                <label>{t('Last Name')}</label>
                                <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} />
                                <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-row col-8 create-marg">
                            <div className="form-group col">
                                <label className="mar-bot-0">Email</label>
                                <p className="create-sm-tx">{t('register.emailNote')}</p>
                                <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                                <ErrorMessage name="email" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-row col-8 create-marg">
                            <div className="form-group col">
                                <label>{t('Password')}</label>
                                <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                                <ErrorMessage name="password" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group col">
                                <label>{t('Confirm Password')}</label>
                                <Field name="confirmPassword" type="password" className={'form-control' + (errors.confirmPassword && touched.confirmPassword ? ' is-invalid' : '')} />
                                <ErrorMessage name="confirmPassword" component="div" className="invalid-feedback" />
                            </div>
                        </div>
                        <div className="form-group">
                            <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                {t('Register')}
                            </button>
                        </div>
                    </div>
                    <div>
                        <h3 className="card-header cust-footer">
                            <Link to="login" className="btn btn-link">{t('Cancel')}</Link>
                        </h3>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export { Register }; 